export enum CommissionType {
    FIXED = 'Fixed',
    PERCENTAGE = 'Percentage'
}